import { render, staticRenderFns } from "./CookInHome.vue?vue&type=template&id=86765068&scoped=true&"
import script from "./CookInHome.vue?vue&type=script&lang=ts&"
export * from "./CookInHome.vue?vue&type=script&lang=ts&"
import style0 from "./CookInHome.vue?vue&type=style&index=0&id=86765068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86765068",
  null
  
)

export default component.exports